import React from 'react';

import { TWorkingHoursContext } from '../../../../types/TWorkingHours';

const WorkingHoursContext = React.createContext({} as TWorkingHoursContext);

export default WorkingHoursContext;
